export const scrollToLastMessage = (container: HTMLElement, behavior: ScrollBehavior = "smooth") => {
  const messages = container.querySelectorAll<HTMLElement>("[data-message]");
  const lastMessage = messages[messages.length - 1];
  if (!lastMessage) return;

  const containerRect = container.getBoundingClientRect();
  const lastMessageRect = lastMessage.getBoundingClientRect();
  const nextTop = container.scrollTop + (lastMessageRect.top - containerRect.top);

  container.scrollTo({
    top: nextTop,
    behavior,
  });
};
